import { GridFilterOperator } from '@mui/x-data-grid-pro';
import { formatTranslation } from 'intl';
import { FiltersTranslationKeys } from 'intl/keys';
import { IntlShape } from 'react-intl';
import { GridFilterValue } from 'components/common/dataGrid/filters/operators';

export const getIsEmptyOperator = (intl: IntlShape): GridFilterOperator => ({
  label: formatTranslation(intl, FiltersTranslationKeys.operatorIsEmpty),
  value: GridFilterValue.IS_EMPTY,
  requiresFilterValue: false,
  getApplyFilterFn: () => (value: unknown) => {
    if (value === null || value === undefined) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'string') return value.trim().length === 0;
    return false;
  },
});

export const getIsNotEmptyOperator = (intl: IntlShape): GridFilterOperator => ({
  label: formatTranslation(intl, FiltersTranslationKeys.operatorIsNotEmpty),
  value: GridFilterValue.IS_NOT_EMPTY,
  requiresFilterValue: false,
  getApplyFilterFn: () => (value: unknown) => {
    if (value === null || value === undefined) return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'string') return value.trim().length > 0;
    return true;
  },
});

export const getDateIsEmptyOperator = (intl: IntlShape): GridFilterOperator => ({
  label: formatTranslation(intl, FiltersTranslationKeys.operatorIsEmpty),
  value: GridFilterValue.IS_EMPTY,
  requiresFilterValue: false,
  getApplyFilterFn: () => (value: unknown) => value === null || value === undefined,
});

export const getDateIsNotEmptyOperator = (intl: IntlShape): GridFilterOperator => ({
  label: formatTranslation(intl, FiltersTranslationKeys.operatorIsNotEmpty),
  value: GridFilterValue.IS_NOT_EMPTY,
  requiresFilterValue: false,
  getApplyFilterFn: () => (value: unknown) => value !== null && value !== undefined,
});
